import React, { useState } from 'react';

import { Button, Modal, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

function HotelAmenity({ amenities }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size="lg">
        <Modal.Header closeButton className="bg-dark" closeVariant="white">
          <Modal.Title>All Amenities</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark">
          <div className="overflow-hidden row-cols-1 row-cols-lg-1 g-2 g-lg-1 py-3">
            <div className="row">
              {amenities.map((amenity) => {
                return (
                  <div className="col-6 fs-6" key={amenity.id}>
                    <FontAwesomeIcon icon={faCheck} className="select-color mx-1" />
                    {amenity.name}
                  </div>
                );
              })}
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Row className="border-bottom">
        <div className="container overflow-hidden row-cols-1 row-cols-lg-1 g-2 g-lg-1 py-3">
          <div className="row">
            {amenities.slice(0, 14).map((amenity) => {
              return (
                <div className="col-6 fs-6" key={amenity.id}>
                  <FontAwesomeIcon icon={faCheck} className="select-color mx-1" />
                  {amenity.name}
                </div>
              );
            })}
            <div className="col-12 text-center">
              <Button onClick={() => handleShow()} className="rounded-pill bg-transparent border-white mt-3">
                All Amenities
              </Button>
            </div>
          </div>
        </div>
      </Row>
    </>
  );
}

export default React.memo(HotelAmenity);
